import { siteDevelopmentUrl } from "../../utility/Index";

export const eventParticipationData = {
  EventParticipation: {
    Title: "Event Participation",
    GeneralTopData: [],
    GeneralBottomData: [],
    Players: {
      Steps: [
        {
          StepTitle: "Understanding Event Types",
          Description: [
            `<a href='${siteDevelopmentUrl}/dashboard'>Kall-Out Events</a>: Open challenges where you can invite other players to compete. Set rules, wager belts or coins, and engage with your opponents.`,
            `<a href='${siteDevelopmentUrl}/dashboard'>Ticketed Events (Exclusive)</a>: Premium events with high-profile matches. Players set up exclusive streams, and audiences purchase tickets to watch.`,
          ],
        },
        {
          StepTitle: "Setting Up Events",
          Description: [
            `Creating a Kall-Out Event: Navigate to the '<a href='${siteDevelopmentUrl}/CreatePublicEventScreen?eventType=Public'>Create new</a>' section, set the game, rules, wager (using belts), and invite your opponent.`,
            "Set the game, rules, wager (using belts), and invite your opponent.",
            "Once the challenge is accepted, the event will be live, and you can start playing.",
            `Organising a Ticketed Event: In the '<a href='${siteDevelopmentUrl}/CreatePublicEventScreen?eventType=Public'>Create new</a>' section, choose 'Exclusive,' set event details, and promote it to attract ticket purchases.`,
            "Set up the event details, including the game, rules, and ticket price.",
            "Choose the platform's built-in streaming service.",
            "Promote the event to attract audience members who will purchase tickets.",
          ],
        },
        {
          StepTitle: "Managing Challenges and Events",
          Description: [
            `My Events Page: Track all your activities on the "<a href='${siteDevelopmentUrl}/events'>My Events</a>" page. Here, you'll see: Events you've organised (both kall-out and ticketed), Challenges you've sent and received, Free & Ticketed events you've signed up to watch or participate in.`,
            "Accepting Challenges: When you receive a challenge invite, review the details and decide whether to accept. Once accepted, the event will be live, and you can start competing at the arranged time and date.",
          ],
        },
        {
          StepTitle: "Streaming Your Events",
          Description: [
            "Choose a Streaming Option: For both free and exclusive events, select your preferred streaming method",
            "YouTube/Twitch: Stream your gameplay live using your existing account.",
            "Platform's Built-in Streaming: Use our platform's streaming service, for ticketed events. This option is integrated with the event system and allows for seamless interaction with the audience.",
          ],
        },
        {
          StepTitle: "Managing Event Thresholds",
          Description: [
            "Ticket Threshold: Each exclusive event has a minimum ticket sales threshold that must be met for the event to go ahead.",
            "Meeting the Threshold: Monitor ticket sales. If the threshold isn't met, you’ll have two options:",
            "Settle the Difference: Pay the difference using your tokens to meet the threshold and keep the event as ticketed.",
            "Switch to Free Event: If you choose not to settle the difference, the event will switch to a kall-out (free) event. All purchased tickets will be refunded, and you can select YouTube or Twitch for the event to be streamed on.",
            "Engage with Your Audience: While streaming, interact with your audience through chat and respond to their comments. Encourage them to send gifts to support you during the stream.",
          ],
        },
        {
          StepTitle: "Managing Tokens and Belts",
          Description: [
            "Wagering Belts: Wager belts in kall-out events, with the winner taking all belts wagered.",
            "Earning Through Ticketed Events: Earn tokens from ticket sales and gifts during streams.",
          ],
        },
        {
          StepTitle: "Notifications and Updates",
          Description: [
            "Stay Informed: You'll receive notifications for all accepted challenges, upcoming events, and audience interactions. Make sure to keep an eye on your notifications to stay updated.",
          ],
        },
      ],
    },
    Audience: {
      Steps: [
        {
          StepTitle: "Understanding Events",
          Description: [
            "Kall-Out Events (Free): These are open challenges between players that you can watch without any cost. They offer a great way to see different players in action and participate in the community.",
            "Ticketed Events (Exclusive): These events require a ticket purchase to watch. They often feature high-profile matchups or special content with added features like exclusive streams or behind-the-scenes access.",
          ],
        },
        {
          StepTitle: "Accessing Events",
          Description: [
            "Sign Up for Free Events: To watch free (kall-out) events, sign up for a free account on the platform. Once signed up, you can join any ongoing free event directly from the “Events” or “Live Now” section.",
            "Buy Tickets for Exclusive Events: For exclusive, ticketed events, purchase a ticket using tokens. Navigate to the “Exclusive Events” section, select your event, and buy a ticket to secure your spot.",
          ],
        },
        {
          StepTitle: "Joining Free (Kall-Out) Events",
          Description: [
            "How to Watch: After signing up, go to the “Events” or “Live Now” section, find a kall-out event, and click “Join” to start watching.",
            "Interacting: During the event, interact via chat, send gifts, and follow the players.",
          ],
        },
        {
          StepTitle: "Participating in Exclusive Events",
          Description: [
            "Access the Event: After buying a ticket, access the event through the “My Events” section at the scheduled time. Click “Join” when the event starts.",
            "Special Features: Exclusive events may offer custom commentary, special camera angles, or post-event discussions",
          ],
        },
        {
          StepTitle: "Interaction During Events",
          Description: [
            "Chat and Engage: Use the chat feature to interact with other viewers and the streamer. Share your thoughts, cheer for your favourite players, and be part of the community.",
            "Sending Gifts: Send gifts during the event to support the streamer. Gifts are purchased with tokens and enhance your engagement with the event.",
          ],
        },
        {
          StepTitle: "Managing Your Events",
          Description: [
            "My Events Page: Keep track of all the events you've signed up for or bought tickets to in the “My Events” section.",
            "Notifications: Receive notifications before the events you've signed up for to ensure you don't miss any action.",
          ],
        },
      ],
    },
  },
};
